import { graphql } from '@/gql'

export const insertUserMutationDocument = graphql(/* GraphQL */ `
  mutation insertUserMutationDocument($input: coassign_user_insert_input!) {
    insert_coassign_user_one(object: $input) {
      updated_at
    }
  }
`)

export const updateUserMutationDocument = graphql(/* GraphQL */ `
  mutation updateUserMutationDocument($id: String!, $input: coassign_user_set_input!) {
    update_coassign_user_by_pk(pk_columns: { id: $id }, _set: $input) {
      updated_at
    }
  }
`)

export const insertUserToDepartmentMutationDocument = graphql(/* GraphQL */ `
  mutation insertUserToDepartmentMutationDocument(
    $input: [coassign_user_to_department_insert_input!]!
  ) {
    insert_coassign_user_to_department(objects: $input) {
      affected_rows
    }
  }
`)

export const updateUserToDepartmentMutationDocument = graphql(/* GraphQL */ `
  mutation updateUserToDepartmentMutationDocument(
    $user_id: String!
    $department_id: String!
    $deletedAt: timestamptz!
    $commit_id: String!
  ) {
    update_coassign_user_to_department(
      where: {
        user_id: { _eq: $user_id }
        department_id: { _eq: $department_id }
        deleted_at: { _is_null: true }
      }
      _set: { deleted_at: $deletedAt, commit_id: $commit_id }
    ) {
      affected_rows
    }
  }
`)

export const insertUserToJobTitleMutationDocument = graphql(/* GraphQL */ `
  mutation insertUserToJobTitleMutationDocument(
    $input: [coassign_user_to_job_title_insert_input!]!
  ) {
    insert_coassign_user_to_job_title(objects: $input) {
      affected_rows
    }
  }
`)

export const updateUserToJobTitleMutationDocument = graphql(/* GraphQL */ `
  mutation updateUserToJobTitleMutationDocument(
    $user_id: String!
    $job_title_id: String!
    $deletedAt: timestamptz!
    $commit_id: String!
  ) {
    update_coassign_user_to_job_title(
      where: {
        user_id: { _eq: $user_id }
        job_title_id: { _eq: $job_title_id }
        deleted_at: { _is_null: true }
      }
      _set: { deleted_at: $deletedAt, commit_id: $commit_id }
    ) {
      affected_rows
    }
  }
`)

export const insertUserToJobSkillMutationDocument = graphql(/* GraphQL */ `
  mutation insertUserToJobSkillMutationDocument(
    $input: [coassign_user_to_job_skill_insert_input!]!
  ) {
    insert_coassign_user_to_job_skill(objects: $input) {
      affected_rows
    }
  }
`)

export const updateUserToJobSkillMutationDocument = graphql(/* GraphQL */ `
  mutation updateUserToJobSkillMutationDocument(
    $user_id: String!
    $job_skill_id: String!
    $deletedAt: timestamptz!
    $commit_id: String!
  ) {
    update_coassign_user_to_job_skill(
      where: {
        user_id: { _eq: $user_id }
        job_skill_id: { _eq: $job_skill_id }
        deleted_at: { _is_null: true }
      }
      _set: { deleted_at: $deletedAt, commit_id: $commit_id }
    ) {
      affected_rows
    }
  }
`)

export const mutateCreateFirebaseUser = graphql(/* GraphQL */ `
  mutation mutateCreateFirebaseUser(
    $email: String!
    $firebase_tenant_id: String!
    $subdomain: String!
  ) {
    CreateFirebaseUser(
      email: $email
      firebase_tenant_id: $firebase_tenant_id
      subdomain: $subdomain
    ) {
      result
    }
  }
`)

export const mutateUpdateFirebaseUser = graphql(/* GraphQL */ `
  mutation mutateUpdateFirebaseUser(
    $firebase_tenant_id: String!
    $firebase_uid: String!
    $email: String!
    $disabled: Boolean
  ) {
    UpdateEmailFirebaseUser(
      firebase_tenant_id: $firebase_tenant_id
      firebase_uid: $firebase_uid
      email: $email
      disabled: $disabled
    ) {
      result
    }
  }
`)

export const updatePasswordDocument = graphql(/* GraphQL */ `
  mutation updatePassword(
    $firebase_tenant_id: String!
    $firebase_uid: String!
    $password: String!
  ) {
    UpdateEmailFirebaseUser(
      firebase_tenant_id: $firebase_tenant_id
      firebase_uid: $firebase_uid
      password: $password
    ) {
      result
    }
  }
`)
